import { BCBadge, BCButton, BCPopover, findMessage } from '@bimser/components';
import React from 'react';
import { DMExplorer, ServiceList } from '../../..';
import ClassNames from '../assets/styles.scss';
import { IDMFileSelectorProps, INavigationItem } from '../entities';
import IconEventInfo from '@bimser/icons/16/event-info';
import classNames from 'classnames/bind';
const cx = classNames.bind(ClassNames);

const DMFileSelector: React.FC<IDMFileSelectorProps> = props => {
	const [okButtonLoading, setOkButtonLoading] = React.useState<boolean>(false);
	const [currentSelection, setCurrentSelection] = React.useState<
		DMExplorer.Entities.INavigationItem[]
	>([]);

	const getPaths = async (secretKeys: string[]) => {
		return await ServiceList.dm.DocumentManagement.Explorer.GetPaths.callPromise({
			secretKeys
		});
	};

	const onOkClick = async () => {
		setOkButtonLoading(true);
		const result: INavigationItem[] = [];

		const pathsResponse = await getPaths(
			currentSelection.filter(item => item.type !== 0).map(item => item.secretKey)
		);

		for (const item of currentSelection) {
			let path: string;
			if (item.type !== 0) {
				path = `${pathsResponse.paths[item.id]}/${item.name}`;
			} else {
				path = item.name;
			}
			result.push({
				...{ ...item, baseItem: { ...item.baseItem, path } },
				path,
				fullPath: path
			});
		}

		props.onOkClick?.(result);
	};

	const onCloseClick = () => {
		props.onCloseClick?.();
	};

	const onSelectionChanged = (items: INavigationItem[]) => {
		if (!items) {
			setCurrentSelection([]);
		} else {
			setCurrentSelection(items);
		}
	};

	const renderSupportedExtensions = () => {
		if (!props.extensions?.length) {
			return null;
		}

		return (
			<BCPopover
				trigger="hover"
				arrow
				content={`${findMessage.get('103714')}: ${props.extensions
					.map(ext => `.${ext}`)
					.join(', ')}`}
			>
				<BCButton
					icon={<IconEventInfo />}
					type={'text'}
				></BCButton>
			</BCPopover>
		);
	};

	const showSelectionStatus = () => {
		if (props.maxFileCount || props.minFileCount) return true;
		return false;
	};

	const renderSelectionCounts = () => {
		let status: 'success' | 'error' = currentSelection.length ? 'success' : 'error';
		let statusText = '';

		if (props.minFileCount && currentSelection.length < props.minFileCount) {
			statusText = findMessage
				.get('103715')
				.replace('{0}', (props.minFileCount || 0).toString());
			status = 'error';
		}

		const text = findMessage
			.get('103716')
			.replace('{0}', currentSelection.length.toString())
			.replace('{1}', (props.maxFileCount || '∞').toString());

		return (
			<BCBadge
				status={status}
				text={statusText ? `${text} (${statusText})` : text}
				style={{ lineHeight: '32px' }}
			/>
		);
	};

	const renderFooter = () => {
		const showSelectionBar = showSelectionStatus();

		return (
			<div className={cx({ DmFileSelectorFooter: true, NoSelectionBar: !showSelectionBar })}>
				{showSelectionBar && renderSelectionCounts()}
				{renderActionButtons()}
			</div>
		);
	};

	const renderActionButtons = () => {
		return (
			<div className={ClassNames.FooterButtons}>
				{renderSupportedExtensions()}
				<BCButton
					key="2"
					text={findMessage.get('100034')}
					onClick={onCloseClick}
				/>
				<BCButton
					key="3"
					disabled={currentSelection.length < (props.minFileCount || 1)}
					text={findMessage.get('100004')}
					type="primary"
					onClick={onOkClick}
					loading={okButtonLoading}
				/>
			</div>
		);
	};

	const currentItem = props.currentItem?.secretKey
		? props.currentItem
		: { id: '#Root', secretKey: null, name: '' };

	return (
		<div className={ClassNames.DmFileSelectorContainer + ' ' + props.containerClassName || ''}>
			<DMExplorer.FileSelector
				currentItem={currentItem}
				extensions={props.extensions}
				onSelectionChange={onSelectionChanged}
				maxFileCount={props.maxFileCount}
				allowMultipleSelection={props.allowMultipleSelection}
			/>
			{renderFooter()}
		</div>
	);
};

export default DMFileSelector;
